﻿<script>
  import { onMount } from "svelte/internal";
  import { dispatchMountEvent } from "./services";
  import { sortBy } from "lodash";

  export let _emitMount;
  export let header = [];
  export let headerClass = [];
  export let body = [];
  export let className = "";
  export { className as class };

  onMount(() => {
    if (_emitMount) {
      dispatchMountEvent();
    }
  });

  const computedHeader = header.map(x => ({ text: x, sort: 0 }));
  const columnSortHandler = index => {
    // sort flag
    let newSortFlag = computedHeader[index].sort * -1;
    if (newSortFlag === 0) newSortFlag = 1;
    // sort rows
    let sortedBody = sortBy(body, item => item[index]);
    if (newSortFlag === -1) sortedBody = sortedBody.reverse();
    body = sortedBody;
    // set sort class
    computedHeader[index].sort = newSortFlag;
    // clear other states
    computedHeader.forEach((x, i) => {
      if (i !== index) x.sort = 0;
    });
  };
</script>

<div class="table-responsive {className}">
  <table class="table table-striped table-hover table-sortable">
    <thead>
      <tr>
        {#each computedHeader as th, i}
          <th
            class="table-col-sortable {th.sort === 1 ? 'asc' : th.sort === -1 ? 'desc' : ''}
            {headerClass[i] ? headerClass[i] : ''}"
            data-toggle="sortable"
            on:click|preventDefault={() => {
              columnSortHandler(i);
            }}>
            {th.text}
          </th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each body as tr}
        <tr>
          {#each tr as td}
            <td>{td}</td>
          {/each}
        </tr>
      {/each}
      {#if !body.length}
        <tr>
          <td colspan="100">
            <div class="text-center text-muted font-italic">No Records</div>
          </td>
        </tr>
      {/if}
    </tbody>
  </table>
</div>
